import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSetRecoilState } from "recoil";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LoginForm } from "../../components/organisms/LoginForm";
import { Member } from "../../common/types/member";
import { request } from "../../common/api";
import { logIdState } from "../../common/states/loginLog";
import { memberState } from "../../common/states/member";
import { BaseResponse } from "../../common/types/baseRespones";
import { AuthTemplate } from "../../components/template/AuthTemplate";
import { GET_GROUP_PERMISSIONS } from "../../common/query-keys";
import {
  writeAccessToken,
  writeRefreshToken,
} from "../../common/functions/authFunctions";

export interface LoginInputs {
  mbrUserId: string;
  mbrUserPwd: string;
}

interface LoginData {
  accessToken?: string;
  refreshToken?: string;
  user: Member;
  logId: number;
}

interface LoginResponse extends BaseResponse<LoginData> {}

const schema = yup
  .object({
    mbrUserId: yup.string().nullable().required("아이디를 입력해주세요"),
    mbrUserPwd: yup.string().nullable().required("비밀번호를 입력해주세요"),
  })
  .required();

export const LoginPage = () => {
  const queryClient = useQueryClient();

  const { control, handleSubmit } = useForm<LoginInputs>({
    resolver: yupResolver(schema),
  });
  const setMember = useSetRecoilState(memberState);
  const setLogId = useSetRecoilState(logIdState);

  const mutation = useMutation({
    mutationFn: (inputs: LoginInputs) => {
      return request<LoginResponse>({
        method: "POST",
        url: "/auth/login",
        data: inputs,
      });
    },
    onSuccess: (res: LoginResponse) => {
      const { data } = res;
      data?.accessToken && writeAccessToken(data.accessToken);
      data?.refreshToken && writeRefreshToken(data.refreshToken);
      data?.user && setMember(data.user);
      data?.logId && setLogId(data.logId);
      window.location.replace("/");
      queryClient.invalidateQueries({ queryKey: [GET_GROUP_PERMISSIONS] });
    },
  });

  const onSubmit = (inputs: LoginInputs) => {
    mutation.mutate(inputs);
  };

  return (
    <AuthTemplate>
      <LoginForm onSubmit={handleSubmit(onSubmit)} control={control} />
    </AuthTemplate>
  );
};
